import React, {useContext, useEffect, useState } from "react";
import NewButton from "./NewButton";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as DOWN } from "../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../assets/icons/filter-up.svg";
import { FormTextInput } from "../Components/FormTextInput";
import { Check } from "react-feather";
import SingleLanguageFilter from "../Screens/Account/OrdersComponents/SingleLanguageFilter";
import { firestore, getFullHttpUrl } from "../firebase.config";
import axios from "axios";
import { NotificationContext } from "../Context/NotificationContext";
import { EAST1, EAST4 } from "../utility/enums";

const EmployeeUpdatePopUp = ({ onClose, id }) => {
  const emailRegex = new RegExp(
    "^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$"
  );
  const { showNotification } = useContext(NotificationContext);
  const [firstName, setFirstName] = useState(id.firstName || "");
  const [lastName, setLastName] = useState(id.lastName || "");
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [invalidNewPass, setInvalidNewPass] = useState(false);
  const [email, setEmail] = useState(id.email || "");
  const [role, setRole] = useState(id.role || "");
  const [currentPass, setCurrentPass] = useState(id.currentPass || "");
  const [newPass, setNewPass] = useState("");
  const [error, setError] = useState("");
  const [selectAll, setSelectAll] = useState(id.role === "Support Plus");
  const [selectedLanguages, setSelectedLanguages] = useState(id.languages || []);
  const [showFilter, setShowFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(
    id.role === "Support" || id.role === "Support Plus" ? "Support" : "Translator"
  );
  const employeeOptions = ["Translator", "Support"];

  const handleEmailChange = (value) => {
    setEmail(value);
    setInvalidEmail(!emailRegex.test(value));
  };

  const handleNewPassChange = (value) => {
    setNewPass(value);
    setInvalidNewPass(value.length < 6);
  };

  useEffect(() => {
    if (id) {
      setSelectedEmployee(id.role === "Support" || id.role === "Support Plus" ? "Support" : "Translator");
      setSelectAll(id.role === "Support Plus");
      setCurrentPass(id.currentPass || "");
      setNewPass("");

      if (!id.firstName && !id.lastName && id.name) {
        const nameParts = id.name.trim().split(" ");
        setFirstName(nameParts[0]);
        setLastName(nameParts.slice(1).join(" ")); // handles multi-part last names
      } else {
        setFirstName(id.firstName || "");
        setLastName(id.lastName || "");
      }

      setEmail(id.email || "");
      setRole(id.role || "");
      setSelectedLanguages(id.languages || []);

    }
  }, [id]);

  const handleSave = async () => {
    if (!firstName || !email) {
      setError("All fields are required");
      return;
    }

    setLoading(true);
    try {
      let updatedRole = selectedEmployee;

      if (selectedEmployee === "Support") {
        updatedRole = selectAll ? "Support Plus" : "Support";
      } else if (selectedEmployee === "Translator") {
        updatedRole = "Translator";
      }

      const updateData = {
        firstName,
        lastName,
        email,
        languages: selectedLanguages,
        status: "Active",
        timestamp: new Date(),
        role: updatedRole,
      };
       if (id?.id) {
        if (newPass.trim()) {
          updateData.currentPass = newPass;
          updateData.newPass = newPass;
        }
        await firestore.collection("users").doc(id.id).update(updateData);
      } else {

        const response = await axios({
          method: 'post',
          url: getFullHttpUrl("createEmployeeUser", EAST4),
          data: {
            firstName,
            lastName,
            email,
            password: newPass,
            name: `${firstName} ${lastName}`,
            role: updatedRole,
            languages: selectedLanguages,
            standardRate: 0,
            expeditedRate: 0,
            method: '',
            methodID: '',
            phone: '',
            country: '',
            timezone: '',
          }

        });
        if (response.status === 201) {
          if (response.data.code === 'auth/email-already-exists') {
            showNotification("Error", "There's already a user with this email. Please, try again.", "error");
          } else if (response.data.code === 'auth/invalid-email') {
            showNotification('Error', "The email address is invalid. Please, try again.", 'error');
          } else if (response.data.code === 'auth/invalid-password') {
            showNotification('Error', "Password is too weak. Please, try again with another one.", 'error');
          } else {
            showNotification("User Created", "The user has been created successfully.", "success");
            console.log("User created and added to Firestore");
            setNewPass("");
            setEmail("");
            setFirstName("");
            setLastName("");
            setCurrentPass("");

            onClose();
          }
        } else {
          showNotification("Error", "User creation failed. Please try again.");
        }
      }

      console.log("Employee saved successfully", updateData);
      setNewPass("");
      onClose();
    } catch (err) {
      console.error("Error saving employee:", err);
      setError("Failed to save employee. Please try again.");
    }
    setLoading(false);
  };

  const isBtnDisabled =
    selectedEmployee === "Translator"
      ? !firstName || !email || invalidEmail || selectedLanguages.length === 0
      : !firstName || !email || invalidEmail || selectedLanguages.length === 0 || invalidNewPass;

  return (
    <div className="newPopUpModalWrap">
      <div className="employeeUpdateModalContainer">
        <h2 className="newPopUpModalTitle">
          {id && id.id ? "Edit Employee" : "Add Employee"}
        </h2>
        {!id.id && (
          <div className="expeditedTeamButton">
            {employeeOptions.map((option) => (
              <div
                key={option}
                className={`memberButton ${selectedEmployee === option ? "selected" : ""}`}
                onClick={() => setSelectedEmployee(option)}
              >
                <p>{option}</p>
              </div>
            ))}
          </div>
        )}
        <div className="quoteDetailsInputsContainer">
          <FormTextInput
            placeholder="First Name"
            value={firstName}
            onChange={setFirstName}
          />
          <FormTextInput
            placeholder="Last Name"
            value={lastName}
            onChange={setLastName}
          />
        </div>
        <div className="quoteDetailsInputsContainer">
          <div className="employeeLanguageInputsContainer">
            <div
              className="accountDetailsFilter"
              style={{ justifyContent: "space-between", borderColor: showFilter === "language" ? "#12ABBF" : "#E6E7E9", }}
              onClick={() => setShowFilter((f) => (f === "language" ? "" : "language"))}
            >
              <p className="accountDetailsFilterText">
                {selectedLanguages.length === 0
                  ? "Language"
                  : selectedLanguages.length <= 2
                    ? selectedLanguages.join(", ")
                    : `Language (${selectedLanguages.length}) `}
              </p>
              {showFilter === "language" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "language" && (
              <SingleLanguageFilter
                setShowModal={setShowFilter}
                setSelectedLanguageFilter={setSelectedLanguages}
                selectedLanguageFilter={selectedLanguages}
              />
            )}
          </div>
          <FormTextInput
            incorrect={invalidEmail}
            clearInputIcon={true}
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
          />
        </div>


        <div className="employeeUpdateforsupport">
          <h4 className="employeePopUpModalTitle">Change Password</h4>

          <div className="employeeDetailsInputsContainer">
            <FormTextInput
              placeholder="Current Password"
              incorrect={error === "current"}
              value={currentPass}
              onChange={setCurrentPass}
              password
              showPasswordIcon
            />
            <FormTextInput
              placeholder="New Password"
              incorrect={error === "new"}
              value={newPass}
              onChange={handleNewPassChange}
              password
              showPasswordIcon
            />
          </div>
        </div>


        {selectedEmployee === "Support" && (
          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Extended Access</h4>
            <div className="hardCopyCheckboxLine">
              <div className={`${selectAll ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
                <Check
                  className="hardCopyCheck"
                  onClick={() => setSelectAll((prev) => !prev)}
                  style={{ opacity: selectAll ? 1 : 0 }}
                />
              </div>
              <p className="hardCopyCheckboxText" onClick={() => setSelectAll((prev) => !prev)}>
                Support Plus
                <span> (can view client names, email addresses, and amounts)</span>
              </p>
            </div>
          </div>
        )}

        <div className="quoteDetailsInputsContainer">
          <NewButton text="Cancel" onClick={onClose} />
          <NewButton
            text={loading ? "Saving..." : "Save"}
            onClick={handleSave}
            disabled={loading || isBtnDisabled}
          />
        </div>
        <Close className="newPopUpModalCloseIcon" onClick={onClose} />
      </div>
    </div>
  );
};

export default EmployeeUpdatePopUp;
